import React, { useState, useContext, useEffect } from "react";
import { CmsAssistantRoutes } from "./../../Routes";
import { NavLink } from "reactstrap";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import { ProductContext } from "../../store";
import Skeleton from "react-loading-skeleton";

const CmsAssistantSidebar = () => {
	const [subMenuOpen, setSubMenuOpen] = useState(null);
	const [websitePlatform, setWebsitePlatform] = useState("");
	const location = useLocation()
	const {
		addPageOpen,
		userLoader,
		websiteData,
		currentWebsiteId,
		userWebsitePlan,
		productTypes
	} = useContext(ProductContext);

	useEffect(() => {
		if (userLoader || !userWebsitePlan || !Array.isArray(userWebsitePlan) || userWebsitePlan.length === 0) {
			return
		}
		if (currentWebsiteId) {
			setWebsitePlatform(websiteData[currentWebsiteId]?.websiteType)
		}
	}, [currentWebsiteId, userLoader, userWebsitePlan])

	useEffect(() => {
		const determineOpenSubmenu = () => {
			const currentPath = location.pathname;
			let openMenu = null;
			
			CmsAssistantRoutes.forEach(route => {
				if (route.subMenu && route.subMenu.length > 0) {
					const hasMatchingSubmenu = route.subMenu.some(subMenu => {
						const fullPath = route.layout + subMenu.path;
						return currentPath === fullPath || currentPath.startsWith(fullPath);
					});
					
					if (hasMatchingSubmenu) {
						openMenu = route.name;
					}
				}
			});
			
			setSubMenuOpen(openMenu);
		};
		
		determineOpenSubmenu();
	}, [location.pathname]);

	const handleTopMenu = (e, cmsRoute) => {
		if (location.pathname && cmsRoute.path && location.pathname !== cmsRoute.layout + cmsRoute.path) {
			return
		}
		if (!cmsRoute.path) {
			e.preventDefault()
		}
		// Collapse logic: if clicking the same menu, close it; otherwise open it and close others
		if (subMenuOpen === cmsRoute.name) {
			setSubMenuOpen(null) // Close if already open
		} else {
			setSubMenuOpen(cmsRoute.name) // Open this one, automatically closes others
		}
	}

	return (
		<div className="innerSideBarContainer" style={{ display: addPageOpen ? 'none' : 'flex' }} >
			<header className="inner-header text-center align-items-center justify-content-start d-flex">
				<i className="fas fa-file-alt stl-text-grey-800" style={{ fontSize: "16px", marginLeft: "8px" }}></i>
				<span className="stl-text-grey-800" style={{ marginLeft: "8px", fontSize: "17px", fontWeight: "600" }}>CMS Assistant</span>
			</header>
			{websitePlatform === "" ?
				<>
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
				</>
				:
				// Only show CMS Assistant sidebar if user has cmsassistant product type
				<nav aria-label="CMS Assistant Navigation">
					<ul className="searchNavigationList">
						{CmsAssistantRoutes.map((cmsRoute, index) => {
							return (
								<React.Fragment key={index}>
									{((!cmsRoute.accessPlans || ( cmsRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => cmsRoute.accessPlans.includes(plan.planId)) ) ) && ( !cmsRoute.availablePlatforms || ( cmsRoute.availablePlatforms && cmsRoute.availablePlatforms.includes(websitePlatform) ) ) && ( !cmsRoute.productType || ( cmsRoute.productType && productTypes.includes(cmsRoute.productType) ) ) ) && (
										<li key={index}>
											<NavLink
												to={cmsRoute.path ? cmsRoute.layout + cmsRoute.path : "#"}
												tag={NavLinkRRD}
												className={`navItem ${cmsRoute.itemClass ? cmsRoute.itemClass : ""}`}
												activeClassName="active"
												onClick={(e) => handleTopMenu(e, cmsRoute)}
											>
												<div className="d-flex align-items-center justify-content-between">
													<div className="iconStringWrap">
														<i className={`fas ${cmsRoute.fontIcon} text-white`} style={{ fontSize: "14px", marginRight: "8px" }}></i>
														{cmsRoute.name}
													</div>
													{cmsRoute.subMenu && cmsRoute.subMenu.length > 0 &&
														<i className={`fas ${subMenuOpen === cmsRoute.name ? "fa-chevron-down" : "fa-chevron-right"}`} style={{ fontSize: "10px" }} />
													}
												</div>
											</NavLink>
											{subMenuOpen === cmsRoute.name && cmsRoute.subMenu && cmsRoute.subMenu.length > 0 &&
												<div id={"linkGroup" + (index + 1)} className="linkGroup">
													<ul>
														{cmsRoute.subMenu.map((subMenu, index) => {
															if (subMenu.menuFlag && (!subMenu.availablePlatforms || (subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform)))) {
																return (
																	<li key={index}>
																		<NavLink
																			to={subMenu.layout + subMenu.path}
																			tag={NavLinkRRD}
																			className={`navItem ${subMenu.itemClass ? subMenu.itemClass : ""}`}
																			activeClassName="active"
																			onClick={(e) => e.stopPropagation()}
																		>
																			{subMenu.name}
																		</NavLink>
																	</li>
																)
															}
															return null
														})}
													</ul>
												</div>
											}
										</li>
									)}
								</React.Fragment>
							)
						})}
					</ul>
				</nav>
			}
		</div>
	);
};

export default CmsAssistantSidebar;
